import React from 'react';

var SvgClockMinor = function SvgClockMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm2.293-4.707a.997.997 0 0 1-.707-.293l-2.293-2.293a.997.997 0 0 1-.293-.707v-4a1 1 0 1 1 2 0v3.586l2 2a.999.999 0 0 1-.707 1.707z"
  }));
};

export { SvgClockMinor as S };
